import { createReducer, on } from '@ngrx/store';

import {
  addNotification,
  deleteNotificationById,
  loadNotifications,
  loadNotificationsFailure,
  loadNotificationsSuccess,
  setLastPageStateNotifications,
  updateIsActiveNotifications,
  updateNotificationById,
} from '@store/notifications/notifications.actions';
import {
  initialStateNotifications,
  notificationsAdapter,
} from '@store/notifications/notifications.state';

export const notificationsReducer = createReducer(
  initialStateNotifications,
  on(loadNotifications, (state) => ({
    ...state,
    loading: true,
    error: undefined,
  })),
  on(loadNotificationsSuccess, (state, { list }) =>
    notificationsAdapter.setAll(list, {
      ...state,
      loading: false,
    }),
  ),
  on(loadNotificationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(updateNotificationById, (state, data) => {
    const { updatedNotification } = data;
    return notificationsAdapter.updateOne(
      {
        id: updatedNotification.id,
        changes: updatedNotification,
      },
      state,
    );
  }),
  on(addNotification, (state, data) => {
    const { newNotification } = data;
    return notificationsAdapter.addOne(newNotification, state);
  }),
  on(deleteNotificationById, (state, data) => {
    const { deletedNotificationId } = data;
    return notificationsAdapter.removeOne(deletedNotificationId, state);
  }),
  on(updateIsActiveNotifications, (state, data) => {
    return notificationsAdapter.updateOne(
      {
        id: data.id,
        changes: {
          isActive: data.isActive,
        },
      },
      state,
    );
  }),
  on(setLastPageStateNotifications, (state, { newPageState }) => {
    return {
      ...state,
      lastPageState: {
        ...state.lastPageState,
        ...newPageState,
      },
    };
  }),
);
